document.addEventListener("alpine:init", () => {
  Alpine.data("modalCremoneBolt", () => ({
    quantity: 1,
    showMaterialOther: false,
    bolts: [
      {
        length: "",
        height_from_bottom: "",
        type: "",
        finish: "",
      },
    ],
    errors: [],

    init() {
      const submitButton = this.$refs.submitButton;

      submitButton.addEventListener("click", (e) => {
        e.preventDefault();

        this.errors = [];
        this.validate();

        if (this.errors.length === 0) {
          this.$refs.form.submit();
        }
      });

      this.$watch("quantity", () => {
        // Update bolts array based on quantity
        const quantity = parseInt(this.quantity);
        if (quantity > this.bolts.length) {
          for (let i = this.bolts.length; i < quantity; i++) {
            this.bolts.push({
              length: "",
              height_from_bottom: "",
              type: "",
              finish: "",
            });
          }
        } else {
          this.bolts.splice(quantity);
        }
      });
    },

    validate() {
      let children = this.$refs.form.querySelectorAll(
        "input, textarea, select",
      );
      let findEmpty = Array.from(children).find((element) => {
        if (element.required && element.value.trim().length < 1) {
          return true;
        }
        return false;
      });

      if (findEmpty) {
        this.errors.push({ message: "Fields marked with * are required" });
      }

      // if (this.showMaterialOther) {
      //   const materialOtherField = this.$refs.form.querySelector(
      //     "input[name='contact[material_other]']",
      //   );
      //   if (!materialOtherField || !materialOtherField.value) {
      //     this.errors.push({ message: "Fields marked with * are required" });
      //   }
      // }

      // this.bolts.forEach((bolt, index) => {
      //   if (!bolt.length)
      //     this.errors.push({
      //       message: `Bolt (${index + 1}) length is required`,
      //     });
      //   if (!bolt.width)
      //     this.errors.push({
      //       message: `Bolt (${index + 1}) width is required`,
      //     });
      //   if (!bolt.thickness)
      //     this.errors.push({
      //       message: `Bolt (${index + 1}) thickness is required`,
      //     });
      //   if (!bolt.quantity)
      //     this.errors.push({
      //       message: `Bolt (${index + 1}) quantity is required`,
      //     });
      // });
    },

    // addBolt() {
    //   const quantity = this.$event.target.value;
    //   this.quantity = quantity;
    //   // this.bolts.push({
    //   //   length: "",
    //   //   width: "",
    //   //   thickness: "",
    //   //   quantity: null,
    //   // });
    // },

    // removeBolt(index) {
    //   this.bolts.splice(index, 1);
    // },
  }));
});
